import { useState, useEffect } from 'react';
import Wrapper from '../utils/msrpWrapper';
import Global from '../globals/globals';

let webSocketInstance: Wrapper | null = null;
console.log("sessionID= ", Global.sessionId);


interface WrapperData {
    host: string;
    port: number;
    username: string;
    password: string;
    sessionId: string;
    serverIp: string;
    serverPort: number;
    companyDomain: string;
}

const DEFAULT_WRAPPER_CONFIG: WrapperData = {
    host: "127.0.0.1",
    port: 9915,
    username: "",
    password: "",
    sessionId: `${Global.sessionId}`,
    serverIp: "35.197.206.178",
    serverPort: 3457,
    companyDomain: "comptest1",
};
export const useWebsocketHook = () => {
    const [socketInstance, setSocketInstance] = useState<Wrapper | null>(webSocketInstance);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);

    const createSocketInstance = (
        username: string,
        password: string,
        companyDomain: string,
        addRoomCallback: any,
        handlereceiveFileMessage: any,
        handleReceiveMessage: any,
        requestController: any,
        notificationController: any,
        controller: any,
        handleSessionActivation: any,
        handleChatListResponse: any,
        setIsCreator: any,
        setAvailableRooms: any,
        addNotification: any,
        handleRemoveMessage: any,
        handleupdateMessage: any,
        handleaddRequest: any,
        handleremoveRequest: any,
        handleaddServerRequest: any,
        handleremoveServerRequest: any,
        handlefindServerRequest: any,
        handleupdateReqStatusById: any,
        handlefindRequest: any,
        handleAddMessageHistory: any,
        clearAllChatRooms: any,
        handleLeaveFromChat: any,
        handleAddParticipant: any,
        handleRemoveParticipant: any,
        updateMessageStatus: any
    ) => {
        try {
            setLoading(true);
            setError(null);

            const wrp = new Wrapper(
                DEFAULT_WRAPPER_CONFIG.host,
                DEFAULT_WRAPPER_CONFIG.port,
                username,
                password,
                companyDomain,
                DEFAULT_WRAPPER_CONFIG.sessionId,
                DEFAULT_WRAPPER_CONFIG.serverIp,
                DEFAULT_WRAPPER_CONFIG.serverPort,
                "",
                addRoomCallback,
                handlereceiveFileMessage,
                handleReceiveMessage,
                requestController,
                notificationController,
                controller,
                handleSessionActivation,
                handleChatListResponse,
                setIsCreator,
                setAvailableRooms,
                addNotification,
                handleRemoveMessage,
                handleupdateMessage,
                handleaddRequest,
                handleremoveRequest,
                handleaddServerRequest,
                handleremoveServerRequest,
                handlefindServerRequest,
                handlefindRequest,
                handleupdateReqStatusById,
                handleAddMessageHistory,
                clearAllChatRooms,
                handleLeaveFromChat,
                handleAddParticipant,
                handleRemoveParticipant,
                updateMessageStatus
            );

            webSocketInstance = wrp;
            setSocketInstance(wrp);
            return wrp;
        } catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
            throw err; // Re-throw to be caught by the login handler
        }
    };

    const resetSocketInstance = () => {
        webSocketInstance = null;
        setSocketInstance(null);
        setError(null);
    };


    return {
        socketInstance,
        loading,
        error,
        setLoading,
        createSocketInstance,
        resetSocketInstance
    };

};
